import { useState } from "react";
import All from "./Navigation/All";
import Application from "./Navigation/Application";
import Ui from "./Navigation/Ui";
import Product from "./Navigation/Product";
import Branding from "./Navigation/Branding";
import Website from "./Navigation/Website";
import Security from "./Navigation/Security";
import Cloud from "./Navigation/Cloud";
import Infra from "./Navigation/Infra";

function Portfolio() {
    const [active, setActive] = useState('All');
    console.log(active);
    return (
        <>
            <section className="pt-32 pb-20 px-6 text-center mx-auto bg-[linear-gradient(135deg,#05001a,#0a0133,#140145)]  from-black to-cyan-900">
                <h1 className="text-5xl font-bold text-white mb-4">PORTFOLIO</h1>
                <p className="text-white text-lg mb-12 max-w-2xl mx-auto">
                    Cybredge Private Limited is a forward-thinking technology company delivering cutting-edge digital solutions to help businesses grow,
                    scale, and succeed in the digital era. We specialize in building reliable, secure, and high-performance software tailored to modern
                    business needs.
                </p>



                <div className="flex flex-wrap justify-center gap-[45px]">

                    <div
                        onClick={() => setActive('All')}
                        className={`cursor-pointer transition font-bold text-lg ${active === 'All' ? 'text-[#FD02FD]' : 'text-white hover:text-[#FD02FD]'}`}>
                        All
                    </div>

                    <div
                        onClick={() => setActive('Website')}
                        className={`cursor-pointer transition font-bold text-lg ${active === 'Website' ? 'text-[#FD02FD]' : 'text-white hover:text-[#FD02FD]'}`}>
                        Website
                    </div>

                    <div
                        onClick={() => setActive('App')}
                        className={`cursor-pointer transition font-bold text-lg ${active === 'App' ? 'text-[#FD02FD]' : 'text-white hover:text-[#FD02FD]'}`}>
                        App
                    </div>

                    <div
                        onClick={() => setActive('Product')}
                        className={`cursor-pointer transition font-bold text-lg ${active === 'Product' ? 'text-[#FD02FD]' : 'text-white hover:text-[#FD02FD]'}`}>
                        Product
                    </div>

                    <div
                        onClick={() => setActive('Branding')}
                        className={`cursor-pointer transition font-bold text-lg ${active === 'Branding' ? 'text-[#FD02FD]' : 'text-white hover:text-[#FD02FD]'}`}>
                        Branding
                    </div>

                    <div
                        onClick={() => setActive('Ui')}
                        className={`cursor-pointer transition font-bold text-lg ${active === 'Ui' ? 'text-[#FD02FD]' : 'text-white hover:text-[#FD02FD]'}`}>
                        UI/UX
                    </div>

                    <div
                        onClick={() => setActive('Security')}
                        className={`cursor-pointer transition font-bold text-lg ${active === 'Security' ? 'text-[#FD02FD]' : 'text-white hover:text-[#FD02FD]'}`}>
                        Security
                    </div>

                    <div
                        onClick={() => setActive('Cloud')}
                        className={`cursor-pointer transition font-bold text-lg ${active === 'Cloud' ? 'text-[#FD02FD]' : 'text-white hover:text-[#FD02FD]'}`}>
                        Cloud
                    </div>

                    <div
                        onClick={() => setActive('Infra')}
                        className={`cursor-pointer transition font-bold text-lg ${active === 'Infra' ? 'text-[#FD02FD]' : 'text-white hover:text-[#FD02FD]'}`}>
                        Infra
                    </div>

                </div>





                <div className="mt-10">
                    {active === 'All' && <All />}
                    {active === 'Website' && <Website />}
                    {active === 'App' && <Application />}
                    {active === 'Product' && <Product />}
                    {active === 'Branding' && <Branding />}
                    {active === 'Ui' && <Ui />}
                    {active === 'Security' && <Security />}
                    {active === 'Cloud' && <Cloud />}
                    {active === 'Infra' && <Infra />}
                </div>
            </section>
        </>
    );
}

export default Portfolio;